<template>
  <div class="container">
    <main role="main">
      <div class="d-flex justify-content-center align-items-center m-5">
        <div class="spinner-border" role="status">
          <span class="sr-only">{{ msg }}</span>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'SendingStep',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
